import { PHONE_FORMAT } from '../../constants';
import { PHONE_CAPTURING_GROUPS } from '../../constants/regexes';
/**
 * Given a phone number in any format, this will return the phone number
 * in the `xxx-xxx-xxxx` format.
 * This will add trailing 0's for phone numbers shorter than 10 characters
 */
export function formatPhoneNumber(value) {
    return String(value)
        .replace(/\D/g, '')
        .concat('0'.repeat(10))
        .slice(0, 10)
        .replace(PHONE_CAPTURING_GROUPS, PHONE_FORMAT.HYPHEN);
}
/**
 * Given a `format` with 3 capturing groups, ie: `$1-$2-$3`
 * this will return a formatting function using the provided `format`.
 */
export var customPhoneFormat = function (format) { return function (value) {
    return String(value)
        .replace(/[^\d]/g, '') // remove all non digits
        .replace(PHONE_CAPTURING_GROUPS, format);
}; };
/**
 * Given a phone number in any format, this will return the phone number
 * in the `(xxx) xxx-xxxx` format. This will not pad or omit any digits.
 */
export var formatPhoneDefault = customPhoneFormat(PHONE_FORMAT.DEFAULT);
/**
 * Given a phone number in any format, this will return the phone number
 * in the `xxx-xxx-xxxx` format. This will not pad or omit any digits.
 */
export var formatPhoneHyphen = customPhoneFormat(PHONE_FORMAT.HYPHEN);
//# sourceMappingURL=format-phone-number.js.map